<template>
  <div class="grm-input-container">
    <input
      ref="input"
      class="grm-input"
      :type="type"
      :value="value"
      :minlength="minlength"
      :maxlength="maxlength"
      :placeholder="placeholder"
      @input="$emit('input', $event.target.value)"
    />
    <p
      v-if="helpText"
      class="grm-input-help-text"
      :class="helpTextClass"
    >{{ helpText }}</p>
    <ul class="grm-input-check-list">
      <li
        v-for="(checkItem, checkItemIndex) in checkList"
        class="grm-input-check-item"
        :key="checkItemIndex"
      >
        <GrmCheckbox
          disabled
          :id="checkItemIndex"
          v-model="checkItem.checked"
        >{{ checkItem.text }}</GrmCheckbox>
      </li>
    </ul>
  </div>
</template>

<script>
import GrmCheckbox from "@/components/Common/input/GrmCheckbox";

export default {
  name: 'GrmInput',
  components: {
    GrmCheckbox
  },
  props: {
    value: { type: [String, Number] },
    type: { type: String, default: 'text' },
    minlength: { type: Number, default: 0 },
    maxlength: { type: Number },
    placeholder: { type: String, default: '' },
    helpText: { type: String, default: '' },
    checkList: { type: Array, default: () => [] },
  },
  computed: {
    helpTextClass() {
      return this.value.length > this.minlength && this.value.length <= this.maxlength ? 'success' : 'error';
    }
  },
}
</script>

<style lang="scss" scoped>
.grm-input-container {}
.grm-input {
  box-sizing: border-box;
  width: 100%;
  height: 48px;
  margin-top: 16px;
  padding: 16px 20px;
  border: 1px solid #e4e4e4;
  border-radius: 6px;
  font-family: 'Roboto', 'Noto Sans KR', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #333333;
  transition: 0.2s ease-out;
  &::placeholder {
    color: #b2b2b2;
  }
  &:focus {
    border-color: $mainColor;
  }
}
.grm-input-help-text {
  font-size: 11px;
  color: #ccc;
  user-select: none;
  &.error {
    color: $errorColor;
  }
  &.success {
    color: $successColor;
  }
}
.grm-input-check-list {
  margin-top: 4px;
  padding: 6px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
</style>